import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}
const NextIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="51"
			height="50"
			viewBox="0 0 51 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect
				width="50"
				height="50"
				rx="25"
				transform="matrix(-1 0 0 1 50.2896 0)"
				fill="white"
			/>
			<path
				d="M21.2896 16L29.2896 25L21.2896 34"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default memo(NextIcon);
